/**
 * GLA-155: katalog urządzeń odpowiada na DWA różne pytania, więc trzyma DWIE listy.
 *
 * `prosthesis_{id}`          — „z czego mogę wybrać" (kreator; bez wycofanych)
 * `prosthesis_{id}_inactive` — „co już jest w tym zamówieniu" (podgląd; także wycofane)
 *
 * Jedna lista nie obsłuży obu pytań: wspólny klucz oznaczałby, że odwiedzenie podglądu
 * wstawia wycofane urządzenia do listy wyboru w kreatorze, czyli cofa GLA-18.
 *
 * Klucz liczy JEDNA funkcja, bo rozjazd między miejscem zapisu a miejscem odczytu daje
 * najgorszy z możliwych objawów: strażnik `!terminalsList.length` widzi „już mam",
 * listy z flagą nigdy nie pobiera, a testy są zielone.
 */
export function terminalListKey(prosthesisId: number, withInactive = false): string {
	return withInactive ? `prosthesis_${prosthesisId}_inactive` : `prosthesis_${prosthesisId}`;
}

/**
 * Adres katalogu dla tego samego pytania co klucz wyżej. Bez flagi MUSI dać dotychczasowy
 * URL bajt w bajt — inaczej kreator zacząłby odpytywać inny zasób niż przed zmianą.
 */
export function terminalListUrl(prosthesisId: number, withInactive = false): string {
	const base = `/prosthesis/${prosthesisId}/terminal`;

	return withInactive ? `${base}?with_inactive=1` : base;
}
